import { Box, Popover, Typography } from '@mui/material';
import { useResponsiveCC } from 'hooks';
import { useTranslation } from 'react-i18next';
import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';
import { BiRadioCircle } from 'react-icons/bi';
import theme, { color } from 'theme';
import './Popover.css';

const PopoverProps = {
    mobile: {
        anchorvertical: 'bottom',
        anchorhorizontal: 'right',
        transformvertical: 'top',
        transformhorizontal: 'right'
    },
    tablet: {
        anchorvertical: 'bottom',
        anchorhorizontal: 'right',
        transformvertical: 'top',
        transformhorizontal: 'right'
    },
    pc: {
        anchorvertical: 'top',
        anchorhorizontal: 'right',
        transformvertical: 'center',
        transformhorizontal: 'left'
    },
    largePc: {
        anchorvertical: 'top',
        anchorhorizontal: 'right',
        transformvertical: 'center',
        transformhorizontal: 'left'
    }
}

const PopoverPwdTextfield = ({ open, anchorEl, setAnchorEl, errors, value }) => {

    const {t} = useTranslation()
    const {device} = useResponsiveCC()

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            disableAutoFocus={true}
            disableEnforceFocus={true}
            anchorOrigin={{
                vertical: PopoverProps[device].anchorvertical,
                horizontal: PopoverProps[device].anchorhorizontal,
            }}
            transformOrigin={{
                vertical: PopoverProps[device].transformvertical,
                horizontal: PopoverProps[device].transformhorizontal,
            }}
            sx={{ borderRadius: theme.spacing(1.5), marginLeft: '20px', pointerEvents: "none"}}
        >
            <div className={`popover-cc-${device}`}>
                <Box sx={{ padding: '20px' }}>
                    <Typography fontWeight={600}>{t('popover.changepwd.pwdMust')}</Typography>
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("8_Characters") ? <AiFillCloseCircle size={13} color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popover.changepwd.8chars')}</span><br />
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("One_Number") ? <AiFillCloseCircle size={13}  color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popover.changepwd.oneNumber')}</span> <br />
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("One_Uppercase") ? <AiFillCloseCircle size={13}  color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popover.changepwd.oneUpperCase')}</span> <br />
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("One_Lowercase") ? <AiFillCloseCircle size={13}  color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popover.changepwd.oneLowerCase')}</span> <br />
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("One_Special") ? <AiFillCloseCircle size={13}  color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popover.changepwd.oneSpecial')}</span> <br />
                    <Typography fontWeight={600}>{t('popover.changepwd.pwdIsNotInclude')}</Typography>
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("ATTT_username") ? <AiFillCloseCircle size={13}  color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popover.changepwd.username')}</span> <br />
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("same_old_pw") ? <AiFillCloseCircle size={13}  color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popover.changepwd.sameCurrentPwd')}</span> <br />
                    {!value ? <BiRadioCircle size={13} /> : (errors?.includes("ATTT") ? <AiFillCloseCircle size={13}  color={color.main}/> : <AiFillCheckCircle color='#00884F' size={13} />)} <span>&nbsp;{t('popupCheckPass.blackList')}</span>
                </Box>
            </div>
        </Popover>
    )
}

export default PopoverPwdTextfield